module.exports = __webpack_public_path__ + "src/assets/img/cerah.6e1e7cd9.svg";